goog.provide("shadow.js.shim.module$react_use$lib$useWindowSize$default");
shadow.js.shim.module$react_use$lib$useWindowSize$default = shadow.js.shim.module$react_use$lib$useWindowSize.default;
